import React, { useContext } from "react";
import style from "./index.module.scss";
import CourseButton from "components/CourseComponents/CourseButton";
import useModalHandler from "utils/useModalHandler";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import ListItem from "components/CourseComponents/Experiment/ListItem";
import { Spin } from "antd";
import useRequest from "utils/useRequest";
import { CourseContext } from "../Store";
import { getCloudDeskTopList } from "service/experiment";
import SettingModal from "components/CourseComponents/Experiment/SettingModal";

export default function Experiment() {
    const modal = useModalHandler();
    const { course } = useContext(CourseContext);
    const [data, { loading }, refreshData] = useRequest(() =>
        getCloudDeskTopList(course.weekTimeId)
    );

    function onOk() {
        refreshData();
        modal.close();
    }

    return (
        <div className={style.root}>
            <div className={style.header}>
                <div className={style.count}>
                    实验计划（{data?.length || 0}）
                </div>

                <CourseButton
                    type="add"
                    onClick={modal.open}
                    className={style.btn}>
                    添加
                </CourseButton>
            </div>

            <Spin spinning={loading}>
                {data?.map(item => (
                    <ListItem
                        key={item.id}
                        data={item}
                        weekTimeId={course.weekTimeId}
                        onChange={refreshData}
                    />
                ))}
                {!data?.length && (
                    <CustomEmpty style={{ padding: "100px 0" }} />
                )}
            </Spin>

            <SettingModal
                course={course}
                visible={modal.visible}
                onCancel={modal.close}
                onOk={onOk}
            />
        </div>
    );
}
